import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type ListProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
  ordered?: boolean;
}>;

export function List({ props }: ListProps) {
  const Tag = props.ordered ? 'ol' : 'ul';

  return (
    <Tag className={props.ordered ? 'my-4 pl-0' : 'my-4 list-none pl-0'}>
      <StructuredContentRenderer doc={props.children} />
    </Tag>
  );
}
